import { StrictMode } from 'react'
import { createRoot } from 'react-dom/client'
import '@alwindows/shared/styles'
import '@alwindows/shared/ui/styles'
import { App } from './App'
import './components/Layout.scss'
import './catalog/ProductCard.scss'
import './catalog/CatalogFilters.scss'
import './pages/Landing.scss'
import './pages/Cart.scss'
import './pages/Checkout.scss'

const root = document.getElementById('al-spare-parts-root')
if (root) {
  createRoot(root).render(
    <StrictMode>
      <App />
    </StrictMode>,
  )
}
